<template>
    <div class="w-full flex justify-center items-center px-8 py-8">
        <div class="relative flex items-center w-full mx-auto ">


            <!-- Step 1 -->
            <div class="relative flex flex-col items-center w-8">
                <div :class="[
                    'rounded-full w-8 h-8 flex items-center justify-center font-semibold border-2 transition-all duration-300',
                    registerStore.step >= 1
                        ? 'bg-gifty-pink border-gifty-pink text-white'
                        : 'bg-white border-gray-300 text-gray-500'
                ]">
                    1
                </div>
                <span :class="[
                    'absolute top-10 text-xs font-medium transition-all duration-300',
                    registerStore.step >= 1 ? 'text-gifty-pink' : 'text-gray-500'
                ]">
                    {{$t('register.stepper.phone')}}
                </span>
            </div>

            <!-- Line 1 -->
            <div :class="[
                'flex-1 h-[2px]  transition-all duration-300',
                registerStore.step > 1 ? 'bg-gifty-pink' : 'bg-gray-300'
            ]"></div>

            <!-- Step 2 -->
            <div class="relative flex flex-col items-center w-8">
                <div :class="[
                    'rounded-full w-8 h-8 flex items-center justify-center font-semibold border-2 transition-all duration-300',
                    registerStore.step >= 2
                        ? 'bg-gifty-pink border-gifty-pink text-white'
                        : 'bg-white border-gray-300 text-gray-500'
                ]">
                    2
                </div>
                <span :class="[
                    'absolute top-10 text-xs font-medium transition-all duration-300',
                    registerStore.step >= 2 ? 'text-gifty-pink' : 'text-gray-500'
                ]">
                    {{$t('register.stepper.verification')}}
                </span>
            </div>

            <!-- Line 2 -->
            <div :class="[
                'flex-1 h-[2px]  transition-all duration-300',
                registerStore.step > 2 ? 'bg-gifty-pink' : 'bg-gray-300'
            ]"></div>

            <!-- Step 3 -->
            <div class="relative flex flex-col items-center w-8">
                <div :class="[
                    'rounded-full w-8 h-8 flex items-center justify-center font-semibold border-2 transition-all duration-300',
                    registerStore.step >= 3
                        ? 'bg-gifty-pink border-gifty-pink text-white'
                        : 'bg-white border-gray-300 text-gray-500'
                ]">
                    3
                </div>
                <span :class="[
                    'absolute top-10 text-xs font-medium transition-all duration-300',
                    registerStore.step >= 3 ? 'text-gifty-pink' : 'text-gray-500'
                ]">
                    {{$t('register.stepper.registration')}}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRegistrationStore } from '@/stores/registrationStore'
const registerStore = useRegistrationStore()
</script>
